import * as Yup from "yup";

const VendorPaymentValidation = Yup.object({
  vendorName: Yup.string().required("Vendor name is required"),
  vendorContact: Yup.string().required("Vendor contact is required"),
  paidAmount: Yup.number()
    .typeError("Amount must be a number")
    .required("Paid amount is required"),
  confirmedBy: Yup.string().required("Confirmed by is required"),
  paymentMode: Yup.string().required("Payment mode is required"),
});

export default VendorPaymentValidation;
